import React from 'react';

type Props = {
  children: React.ReactNode[];
};

const LineWrapper = ({ children }: Props) => {
  const newChildren: React.ReactElement[] = [];

  React.Children.forEach(children, (child, i) => {
    if (i % 2 === 0) {
      newChildren.push(
        <div className="basis-2/12 ml-2" key={i}>
          {child}
        </div>
      );
    } else {
      const previousDiv = newChildren[newChildren.length - 1];
      newChildren[newChildren.length - 1] = (
        <div className="basis-2/12 ml-2" key={i - 1}>
          {previousDiv.props.children}
          {child}
        </div>
      );
    }
  });

  return (
    <>
      {newChildren}
      <div className="flex-grow basis-full shrink" />
    </>
  );
};

export default LineWrapper;
